/** Prevents race conditions on concurrent token refresh requests */
class TokenRefreshManager {
  private refreshPromise: Promise<unknown> | null = null;
  private isRefreshing = false;

  async refresh<T>(refreshFn: () => Promise<T>): Promise<T> {
    if (this.isRefreshing && this.refreshPromise) {
      return this.refreshPromise as Promise<T>;
    }

    this.isRefreshing = true;
    const promise = refreshFn().finally(() => {
      this.isRefreshing = false;
      this.refreshPromise = null;
    });
    this.refreshPromise = promise;

    return promise;
  }

  reset(): void {
    this.isRefreshing = false;
    this.refreshPromise = null;
  }
}

export const tokenRefreshManager = new TokenRefreshManager();
